import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Body } from '@nerdwallet/currency';
import {
  Container as AB,
  Variant,
  Control,
} from '@nerdwallet/nw-client-lib/ab';

const HeroNavTile = (props) => {
  const makeTile = ({
    nav,
    IconComponent,
    iconColor,
    backgroundColor,
    url,
  }) => {
    return (
      <a href={url} className="hero-nav__tile-container">
        <div className="hero-nav__tile">
          <div style={{ backgroundColor }} className="hero-nav__icon-container">
            <IconComponent
              color={iconColor}
              size={48}
              className={classNames([
                classes(['width-100', 'height-100', 'padding-all-1']),
              ])}
            />
          </div>
          <Body className="hero-nav__text">{nav}</Body>
        </div>
      </a>
    );
  };

  if (props.nav === 'Mortgage') {
    return (
      <AB experimentID="welcome_front_page_mort_tile">
        <Control>
          {makeTile({
            ...props,
            url:
              '/hub/category/mortgages?trk=hp_tiles_bestmortgage&trk_copy=hpbestmortgage_cntrl',
          })}
        </Control>
        <Variant variantName="best_mort_lenders">
          {makeTile({
            ...props,
            url:
              '/mortgages/best-mortgage-lenders?trk=hp_tiles_bestmortgage&trk_copy=hpbestmortgage_var',
          })}
        </Variant>
      </AB>
    );
  }

  return makeTile(props);
};

HeroNavTile.propTypes = {
  nav: PropTypes.string,
  IconComponent: PropTypes.elementType,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  url: PropTypes.string,
};

HeroNavTile.displayName = 'HeroNavTile';

export default HeroNavTile;
